var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGrid8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 11.251h-5.25v-9.22c3.3.2 5.25 2.33 5.25 5.78v3.44zM22 16.19c0 3.45-1.95 5.58-5.25 5.78v-9.22H22v3.44zM7.25 21.97C3.95 21.77 2 19.64 2 16.19v-3.44h5.25v9.22zM7.25 11.251H2v-3.44c0-3.45 1.95-5.58 5.25-5.78v9.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 2v9.25h-6.5V2h6.5zM15.25 12.75V22h-6.5v-9.25h6.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGrid8);
export default __webpack_public_path__ + "static/media/vuesax-bold-grid-8.f6c22e69c85d4bef308ef9d17cd39c69.svg";
export { ForwardRef as ReactComponent };